import extendUpdate from '../../helpers/extendUpdate'
import update from 'immutability-helper'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const statistics = {
	[ActionsTypes.RESET_STATISTICS]: (state) =>
		update(state, {
			statistics: {
				data: {
					$set: {},
				},
			},
		}),
	[ActionsTypes.GET_STATISTICS]: (state) =>
		update(state, {
			statistics: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				data: {
					$set: {},
				},
			},
		}),
	[ActionsTypes.GET_STATISTICS_SUCCESS]: (state, payload) =>
		update(state, {
			statistics: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				data: {
					$set: payload,
				},
			},
		}),
	[ActionsTypes.GET_STATISTICS_ERROR]: (state) =>
		update(state, {
			statistics: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.EXPORT_STATISTICS]: (state) =>
		update(state, {
			statistics: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				data: {
					$set: {},
				},
			},
		}),
	[ActionsTypes.EXPORT_STATISTICS_SUCCESS]: (state, payload) =>
		update(state, {
			statistics: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				data: {
					$set: payload,
				},
			},
		}),
	[ActionsTypes.EXPORT_STATISTICS_ERROR]: (state) =>
		update(state, {
			statistics: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: true,
				},
			},
		}),
}

export default statistics